// Słowniki urlopowe — wspólne dla Ustawień konta i zakładki Kadry.
export const LEAVE_TYPES = [
  { value: 'VACATION', text: 'Wypoczynkowy (z puli)' },
  { value: 'ON_DEMAND', text: 'Na żądanie (z puli)' },
  { value: 'HOURLY', text: 'Wyjście godzinowe (z puli)' },
  { value: 'SPECIAL', text: 'Okolicznościowy' },
  { value: 'UNPAID', text: 'Bezpłatny' },
  { value: 'OTHER', text: 'Inny' },
];

const TYPE_LABELS = Object.fromEntries(LEAVE_TYPES.map((t) => [t.value, t.text]));
const STATUS_LABELS = {
  PENDING: 'Oczekuje',
  APPROVED: 'Zatwierdzony',
  REJECTED: 'Odrzucony',
  CANCELLED: 'Anulowany',
};
const STATUS_COLORS = {
  PENDING: 'orange',
  APPROVED: 'success',
  REJECTED: 'error',
  CANCELLED: 'grey',
};

export function leaveTypeLabel(t) { return TYPE_LABELS[t] || t; }
export function leaveStatusLabel(s) { return STATUS_LABELS[s] || s; }
export function leaveStatusColor(s) { return STATUS_COLORS[s] || 'grey'; }

export function fmtPoolHours(totalHours) {
  const d = Math.floor((totalHours || 0) / 8);
  const g = (totalHours || 0) % 8;
  return g ? `${d} dni ${g} godz.` : `${d} dni`;
}
